import { getWindowObject } from './get-window-object';

export const isAndroidWebView = () =>
    /android/i.test(getWindowObject('navigator')?.userAgent ?? '');
